<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;">
				<s-header-top></s-header-top>
			</el-header>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>				
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/expert' }">专家导师</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/expertDetail' }">详情</el-breadcrumb-item>
					</el-breadcrumb>
						
					<div class="page">
						<div class="page_body">
							<el-row class="detail_info mar_bottom">
								<el-col :span="6" class="detail_info_image">
									<el-image style="width: 100%; height: 100%" :src="item.image?imgPath(item.image) : require('../../static/pro.jpg')" fit="contain"></el-image>
								</el-col>
								<el-col :span="18" class="detail_info_mark">
									<el-row class="name mar_bottom10">
										<el-col :span="24">
											{{item.name}} 
										</el-col>
									</el-row>
									<el-row class="company mar_bottom10">
										<el-col :span="24">
											擅长领域：{{item.workarea}}
										</el-col>
									</el-row>
									<el-row class="mar_bottom10">
										<el-col :span="24">
											工作单位：{{item.company}}
										</el-col>												
									</el-row>
									<el-row class="mar_bottom10">
										<el-col :span="24">
											昵称：{{item.title}}
										</el-col>												
									</el-row>
									<el-row class="buttons" type="flex">											
										<div class="call" @click="call(item.telephone)"><i class="el-icon-chat-dot-round"></i>联系我</div>
									</el-row>
								</el-col>
							</el-row>
							
							<el-row class="remark  mar_bottom">
								<el-col :span="24" class="lab_hr">
									<div class="lab mar_bottom10">专家介绍</div>
								</el-col>
								<el-col :span="24">
									<p v-html='item.info'></p>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>	
</template>

<script>
import sHeaderTop from '@/components/header_top'
import sHeader from '@/components/header'
import sFooter from '@/components/footer'
import sCopyRight from '@/components/copy-right'
import { expertDetail } from '@/api';
export default {
  name: 'supporterDetail',
  components:{
	sHeaderTop,
	sHeader,
	sFooter,
	sCopyRight
  },
  data () {
    return {
  		id: '',
  		item: null
    }
  },
  mounted(option) {
  	this.id = this.$route.query.id,  //接受参数关键代码
  	this.getExpertDetail(this.id)
  },
  methods:{
  	getExpertDetail(id){
  		let _this = this
  		expertDetail({
  		  id: id
  		}).then(res=> {
  			_this.item = res.data
  		})
  	},
	//图片地址
	imgPath(oldPath){			
		return this.$imgBaseUrl + oldPath
	},
	//打电话
	call(phone){
		this.$alert( (phone)?phone:'暂未提供','咨询热线', {
			confirmButtonText: '确定',
			callback: action => {
			}
		});
	},
  }
}
</script>

<style lang="scss" scoped>

.page_body{
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}


.detail_info_image,.detail_info_mark{
	height: 258px;
}

.name{
	font-weight: 600;
}
.company{	
	color: rgba(38, 124, 228, 1);
}


.call{
	height: 36px;
	width: 100px;
	background-color: #F5F5F5;
	border: 1px solid #BBBBBB;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	margin-right: 30px;
	font-weight: 600;
	cursor: pointer;
}
.remark{
	width: 100%;
	>>> img{
		width:100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/expert-detail.vue